import React from 'react';
import PropTypes from 'prop-types';
import { UploadedPhoto } from '../../prop-types';
import { PandaView } from '../../../_utils/image-editor';
import Spinner from '../../../_utils/spinner';

export default function ImageEditPreview({
  style,
  photo
}) {
  if (!photo) {
    return <Spinner style={style} />;
  }

  return (
    <PandaView
      {...photo}
      resolution="full-edit-preview"
      style={{ ...style, objectFit: 'contain' }}
      cropEdges
    />
  );
}

ImageEditPreview.propTypes = {
  style: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  photo: UploadedPhoto
};

ImageEditPreview.defaultProps = {
  photo: null
};

